var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "14px",
    viewBox: "0 0 24 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "For-Prezo",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "32---Brand-Guide---Digital-Mocks",
    transform: "translate(-827.000000, -835.000000)",
    stroke: "#FEFEF6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Phone---Immersive-Menu",
    transform: "translate(636.000000, 52.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Navigation",
    transform: "translate(-72.000000, -35.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Close",
    transform: "translate(263.000000, 813.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.281893823,6.40386617 L23.7181062,17.5961338 M23.7181062,6.40386617 L0.281893823,17.5961338",
    id: "Icon---Close"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.d8a98749.svg";
export { ForwardRef as ReactComponent };